import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';
import {
  DASHBOARD_ANNOUNCEMENTS_API_PATH,
  type Announcement,
  type ApiResponse,
} from '@fluenceur/types';

async function fetchAnnouncements(): Promise<Announcement[]> {
  const response = await api.get<ApiResponse<Announcement[]>>(DASHBOARD_ANNOUNCEMENTS_API_PATH);
  return response.data.data ?? [];
}

export const announcementsQueryKey = (brandId: string | null) =>
  ['announcements', brandId] as const;

export function useAnnouncementsQuery(brandId: string | null = null) {
  return useQuery<Announcement[], Error>({
    queryKey: announcementsQueryKey(brandId),
    queryFn: fetchAnnouncements,
    enabled: Boolean(brandId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes
  });
}
